import React from 'react'
// Routing
import { Link } from 'react-router-dom'

// Styling
import styled from 'styled-components'

import { motion } from 'framer-motion'

// Importing Images
import gt from '../images/graphintunes/gt.png'
import gt1 from '../images/graphintunes/gt1.png'
import gt2 from '../images/graphintunes/gt2.png'
import gt3 from '../images/graphintunes/gt3.png'
import gt4 from '../images/graphintunes/gt4.png'
import gt5 from '../images/graphintunes/gt5.png'
import gt6 from '../images/graphintunes/gt6.png'
import gt7 from '../images/graphintunes/gt7.png'

// Animations, Scroll and Icons
import { pageAnimation, Fade, imageAnimation, FadeLine } from './Animation'
import { ScrollToTop } from './ScrollToTop'
import { IoCaretBackCircleOutline } from 'react-icons/io5'
import { IconContext } from 'react-icons'

const ProjectInfoGraphinTunes = () => {
    return (
        <ProjectContainer
            variants={pageAnimation}
            initial="hidden"
            animate="show"
        >
            <IconContext.Provider
                value={{
                    color: 'white',
                    size: '70px',
                    style: { marginLeft: '3rem' },
                }}
            >
                <Link to="/">
                    <Logo>
                        <motion.h2 variants={Fade}>Chirag Rao</motion.h2>
                        <motion.div variants={Fade}>
                            <IoCaretBackCircleOutline className="back" />
                        </motion.div>
                    </Logo>
                </Link>
            </IconContext.Provider>
            <div className="header">
                <motion.h1 variants={FadeLine} style={{ fontSize: '4rem' }}>
                    Graphin' Tunes
                </motion.h1>
                <motion.h3 variants={Fade}>
                    Beautiful, Interactable and Insightful Graphs based on your
                    Spotify Recent Songs
                </motion.h3>
                <Hide>
                    <motion.img
                        variants={imageAnimation}
                        src={gt}
                        style={{ margin: '1rem 0rem' }}
                        alt="gtimage"
                    />
                </Hide>
                <Hide>
                    <motion.img
                        variants={imageAnimation}
                        src={gt1}
                        style={{
                            margin: '1rem 0rem',
                        }}
                        alt="gtimage"
                    />
                </Hide>
            </div>
            <div className="content">
                <div className="top">
                    <div className="text">
                        <motion.h1 variants={FadeLine}>Introduction</motion.h1>
                        <motion.p variants={Fade}>
                            Graphin' Tunes is a web application that gives you
                            various interactive beautiful and colorful insights
                            on your listening tastes and preferences in a
                            beautiful interface. It plots minimal and elegant
                            graphs which you can use to analyze the melodies and
                            the characteristics of your recently played songs.
                            The web application is best if viewed on a laptop or
                            a desktop, but it is responsive for smaller devices
                            as well.
                            <br />
                            <br />
                            <b>
                                Web Application -{' '}
                                <a
                                    style={{ color: '#23d997' }}
                                    href="https://graphin-tunes-tbij.onrender.com/"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    https://graphin-tunes-tbij.onrender.com/
                                </a>
                            </b>
                        </motion.p>
                    </div>
                    <div className="imageflex">
                        <Hide>
                            <motion.img
                                variants={imageAnimation}
                                src={gt2}
                                alt=""
                            />
                            <ImgDesc>
                                Some elegant charts plotted based on your
                                favorite songs
                            </ImgDesc>
                        </Hide>
                        <div className="textinner">
                            <motion.h3 variants={Fade}>
                                How this App works
                            </motion.h3>
                            <motion.p variants={Fade}>
                                <b style={{ color: '#23d997' }}>1.</b>{' '}
                                Graphin-Tunes first redirects you to the secure
                                Spotify Authentication page and handles
                                Spotify's authentication flow.
                                <br />
                                <b style={{ color: '#23d997' }}>2. </b> After
                                that, it then fetches data from the Spotify API,
                                data specifically being your recently played
                                songs and your user-name.
                                <br />
                                <b style={{ color: '#23d997' }}>3. </b>{' '}
                                Following the above step, Graphin-Tunes uses the
                                Chart.js API to plot beautiful, interactable,
                                animated and insightful graphs of the songs, and
                                also compare them side-by-side.
                                <br />
                                <b style={{ color: '#23d997' }}>4. </b> The end
                                result is that you now understand your music
                                tastes a lot better and have new insights on
                                what makes your ears ascend to Cloud Nine!☁🎶
                                <br />
                            </motion.p>
                        </div>
                    </div>
                </div>
                <div className="imageflex1">
                    <Hide>
                        <motion.img
                            variants={imageAnimation}
                            src={gt3}
                            alt="gt"
                        />
                    </Hide>
                    <div className="textinner">
                        <motion.h3 variants={Fade}>
                            Different Audio Features analyzed by Graphin-Tunes
                        </motion.h3>
                        <motion.p variants={Fade}>
                            Graphin-Tunes analyzes various Audio Features of
                            your recently played favourite songs like
                        </motion.p>
                        <UnorderedList>
                            <br />
                            <AudioList>Danceability</AudioList>
                            <AudioList>Acousticness</AudioList>
                            <AudioList>Energy</AudioList>
                            <AudioList>Valence</AudioList>
                            <AudioList>Tempo</AudioList>
                            <div
                                style={{
                                    marginTop: '1rem',
                                    color: 'white',
                                    fontSize: '1.5rem',
                                }}
                            >
                                And much more!!
                            </div>
                        </UnorderedList>
                    </div>
                </div>
                <div className="imageflex">
                    <Hide>
                        <motion.img
                            variants={imageAnimation}
                            src={gt7}
                            alt="gt"
                        />
                    </Hide>

                    <div className="textinner">
                        <motion.h3 variants={Fade}>
                            Want more Information?
                        </motion.h3>
                        <motion.p variants={Fade}>
                            Check out my very well documented open-source
                            repository of this project on Github! The README
                            file of my repo documents the Tech-Stack, Privacy
                            Concerns of Users, Requirements, some important Tips
                            and points to be taken care of and most importantly,
                            an indepth understanding of each of the audio
                            features!
                        </motion.p>
                    </div>
                </div>
                <ButtonWrapper>
                    <div>
                        <motion.button variants={Fade}>
                            <a
                                style={{
                                    textDecoration: 'none',
                                    color: 'white',
                                }}
                                href="https://graphin-tunes-tbij.onrender.com/"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                Visit the Website!
                            </a>
                        </motion.button>
                    </div>

                    <motion.button variants={Fade}>
                        <a
                            style={{ textDecoration: 'none', color: 'white' }}
                            href="https://github.com/SpaceFace02/Graphin-Tunes"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            View the Github Repo
                        </a>
                    </motion.button>
                </ButtonWrapper>
                <Note>
                    This website will take around 15sec to load for the first
                    time only, as I'm on free tier xD.
                </Note>
                <div className="gallery">
                    <motion.h1 variants={FadeLine}>Gallery</motion.h1>
                    <Hide>
                        <motion.img
                            variants={imageAnimation}
                            src={gt4}
                            alt=""
                        />
                    </Hide>
                    <Hide>
                        <motion.img
                            variants={imageAnimation}
                            src={gt5}
                            alt=""
                        />
                    </Hide>
                    <Hide>
                        <motion.img
                            variants={imageAnimation}
                            src={gt6}
                            alt=""
                        />
                    </Hide>
                </div>
            </div>
            <ScrollToTop />
        </ProjectContainer>
    )
}

const Note = styled.p`
    color: white;
    font-size: 0.4em;
    margin-top: 4px;
`

export const Logo = styled(motion.div)`
    position: absolute;
    top: 10px;
    left: 10px;
    font-family: 'Lobster';
    font-size: '1rem';
    float: right;
    display: flex;
    align-items: flex-end;
    padding: 0rem 1rem;
    margin: 2rem 0rem;
    .back {
        display: none;
    }
    @media screen and (max-width: 520px) {
        h2 {
            display: none;
        }
        .back {
            display: block;
        }
    }
`

const AudioList = styled.li`
    color: #23d997;
    margin: 0.3rem;
`

const UnorderedList = styled.ul`
    display: table;
    margin: auto;
    li {
        font-size: 1.5rem;
    }
`

export const Message = styled(motion.div)`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const ImgDesc = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -8rem;
    color: white;
    font-size: 1.1rem;
    font-weight: bold;
`

export const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 5rem;
    margin-top: 3rem;
`

export const ProjectContainer = styled(motion.div)`
    max-width: 3000px;
    .header {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex-wrap: wrap;
        img {
            width: 100%;
            height: 30rem;
            object-fit: contain;
        }
    }
    .content {
        padding: 10px;
        .text {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 1rem 0rem 0rem 4rem;
            width: 90%;

            @media (max-width: 900px) {
                margin-left: -0.5rem;
            }
        }
        p {
            margin: auto;
        }
    }

    font-family: 'Quicksand', sans-serif;
    .gallery {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h1 {
            width: 70%;
        }
        img {
            width: 1000px;
            margin: 1rem 0rem;
            padding: 1rem 0rem;
        }
        @media screen and (max-width: 520px) {
            img {
                width: 100%;
                height: 65vh;
                margin: 1rem 0rem;
                padding: 1rem 0rem;
            }
        }
    }
    .imageflex {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-wrap: wrap;
        flex-direction: row;
        img {
            width: 700px;
            height: 700px;
            object-fit: contain;
            margin: 0rem 0rem 0rem 1rem;
        }
        .textinner {
            max-width: 800px;
        }
    }
    .imageflex1 {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-wrap: wrap;
        flex-direction: row-reverse;
        img {
            width: 700px;
            height: 700px;
            object-fit: contain;

            margin: 2rem 0rem 0rem 1rem;
        }
        .textinner {
            max-width: 800px;
        }
    }

    h1 {
        color: white;
        font-weight: bolder;
        font-size: 3rem;
        padding: 1rem 0rem 2rem 0rem;
        text-align: center;
        font-size: 5rem;
        color: #23d997;
        border-bottom: 2px solid #23d997;
    }
    h3 {
        color: white;
        font-size: 2rem;
        font-weight: bolder;
        padding: 3rem 0rem 2rem 0rem;
        text-align: center;
    }
    p {
        margin: 4rem 0rem;
        color: white;
        font-size: 1.7rem;
        padding: 2rem 4rem;
        max-width: 1000px;
    }

    @media screen and (max-width: 520px) {
        img {
            width: 80%;
            height: 80vh;
            margin: 1rem 0rem;
            padding: 1rem 0rem;
        }
        p {
            font-size: 2rem;
        }
        h1 {
            font-size: 4rem;
        }
        h3 {
            font-size: 3.2rem;
        }
    }
`

export const Hide = styled.div`
    overflow: hidden;
`

export default ProjectInfoGraphinTunes
